var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_751_87824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 12.75V10.875C12.375 10.7092 12.4408 10.5503 12.5581 10.4331C12.6753 10.3158 12.8342 10.25 13 10.25H20.5C20.6658 10.25 20.8247 10.3158 20.9419 10.4331C21.0592 10.5503 21.125 10.7092 21.125 10.875V19.625C21.125 19.7908 21.0592 19.9497 20.9419 20.0669C20.8247 20.1842 20.6658 20.25 20.5 20.25H18.625V22.125C18.625 22.47 18.3438 22.75 17.9956 22.75H10.5044C10.422 22.7505 10.3402 22.7347 10.264 22.7035C10.1877 22.6723 10.1183 22.6264 10.0598 22.5683C10.0013 22.5102 9.95487 22.4412 9.92316 22.3651C9.89145 22.289 9.87508 22.2074 9.875 22.125L9.87688 13.375C9.87688 13.03 10.1581 12.75 10.5063 12.75H12.375ZM11.1269 14L11.125 21.5H17.375V14H11.1269ZM13.625 12.75H18.625V19H19.875V11.5H13.625V12.75Z",
    fill: "#0869FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_751_87824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.7fe7540130b4e97d27bdd651d4295159.svg";
export { ForwardRef as ReactComponent };